module.exports = __webpack_public_path__ + "static/media/btn_check.11ee227f.png";